import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appPhoneMask]'
})
export class PhoneMaskDirective {

  private readonly dialCode = '+1 ';

  constructor(private ngControl: NgControl) {}

  @HostListener('input', ['$event'])
  onInput(event: any) {
    let value = event.target.value || '';

    // +1 hatao processing ke liye
    value = value.replace(this.dialCode, '');

    // Sirf digits rakho (10 max)
    let digits = value.replace(/\D/g, '').substring(0, 10);

    let formatted = '';
    if (digits.length === 0) {
      formatted = '';
    } else if (digits.length <= 3) {
      formatted = `(${digits}`;
    } else if (digits.length <= 6) {
      formatted = `(${digits.slice(0,3)}) ${digits.slice(3)}`;
    } else {
      formatted = `(${digits.slice(0,3)}) ${digits.slice(3,6)}-${digits.slice(6)}`;
    }

    // Agar kuch type hua hai to +1 add karo
    const finalValue = formatted ? this.dialCode + formatted : '';

    // Control update bina loop
    this.ngControl.control?.setValue(finalValue, { emitEvent: false });
  }
}
